import React, { useState } from 'react';
import './App.css';
import {
	AuthenticatedTemplate,
	UnauthenticatedTemplate,
	useMsal,
} from '@azure/msal-react';
import { RootState } from '../state/RootState';
import { MSALAuth } from '../state/authentication/MSALAuth';
import { IAuth } from '../state/authentication/IAuth';
import { AuthenticatedApp } from './AuthenticatedApp';
import MSALSignIn, { MSALSignInState } from './MSALSignIn';

export interface IAppProps {
	auth: IAuth;
}

export const AppWithMSALAuth: React.FunctionComponent<IAppProps> = (props: IAppProps) => {
	let msalContext = useMsal();

	if (props.auth instanceof MSALAuth) {
		(props.auth as MSALAuth).setContext(msalContext);
	}

	const [rootState] = useState(new RootState(props.auth));

	return (
		<>
			<UnauthenticatedTemplate>
				<MSALSignIn state={new MSALSignInState(msalContext)} rootState={rootState} />
			</UnauthenticatedTemplate>

			<AuthenticatedTemplate>
				<AuthenticatedApp RootState={rootState} />
			</AuthenticatedTemplate>
		</>
	);
};
